// Copyright (C) 2021 Bystronic Laser AG

import { WccAlertMetric, AlertOperator } from './enums/AlertsEnums';

export class WccAlertNotification {
  constructor(
    public id: number,
    public deviceName: string,
    public metric: WccAlertMetric,
    public operator: AlertOperator,
    public thresholdValue: number,
    public currentValue: number,
    public timestampNotification: string,
  ) {}
}
